<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.pressure_test_planning.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_pressure_test_planning'], ['read'])" title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickCheck="onClickCheck"
                        @rowClickPDF="onPDF('table', ...arguments)"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        @rowClickRevision="onRevision">
                    </data-table>

                    <b-btn class="btn btn-default mt-2 mr-1" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_pressure_test_planning'], ['create'])">
                        <i class="fa fa-plus-circle mr-1"></i> {{$t('general.pressure_test_planning.create_button')}}
                    </b-btn>

                    <span v-if="this.$store.getters.hasPermission(['project_pressure_test_planning'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3 mr-1" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.pressure_test_planning.import_button') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>

                    <span v-if="this.$store.getters.hasPermission(['project_pressure_test_planning'], ['read']) && getData.rowData.length > 0" @click="onPDF('button', ...arguments)">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-dark mt-3 text-white mr-1">
                            <span><i class="fa fa-file-pdf-o mr-1"></i> {{ $t('general.buttons.pdf_button') + this.currentPage }}</span>
                        </label>
                        <label v-else class="btn btn-dark mt-3 mr-1 text-white disabled">
                            <span><i class="fa fa-file-pdf-o mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>

                    <span v-if="this.$store.getters.hasPermission(['project_pressure_test_planning'], ['read', 'update']) && getData.rowData.length > 0" @click="onAllocateIsos">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-success mt-3 text-white">
                            <span><i class="fa fa-paperclip mr-1"></i> {{ $t('general.buttons.allocate_isos')  }}</span>
                        </label>
                        <label v-else class="btn btn-success mt-3 text-white disabled">
                            <span><i class="fa fa-paperclip mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>

                <div class="row">
                    <div class="col-sm-12">
                        <span v-if="this.$store.getters.hasPermission(['project_revisions'], ['read']) && getData.rowData.length > 0">
                            <i class="fa fa-2x fa-list-alt text-info"></i> - {{$t('general.buttons.revision')}} &nbsp; &nbsp;
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" id="saveModal" :title="actionTitle" size="lg" @ok="saveAction" @hidden="modalHidden" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_pressure_test_planning'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.test_circuit_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.test_circuit_no">
                        </div>
                    </div>

                    <div class="row mb-3"> 
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test_team') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedPressureTestTeam"
                                :options="currentPressureTestTeam"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPressureTestTeamLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onPressureTestTeamSearch"
                                @input="updatePressureTestTeam"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedPressureTestTeam != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPressureTestTeam"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.pressure_test_team_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test_user') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedPressureTestUser"
                                :options="currentPressureTestUser"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPressureTestUserLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onPressureTestUserSearch"
                                @input="updatePressureTestUser"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedPressureTestUser != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPressureTestUser"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.pressure_test_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.delayed') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <toggle-button v-model="model.delayed" :sync="true" :value="false" :color="{checked: '#ff471a'}" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.all_works_finished') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.all_works_finished" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_medium') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <autocomplete @search="onTestingMediumSearch" :options="currentTestingMedium" v-model="model.testing_medium"></autocomplete>
                        </div>
                    </div>
                    
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_pressure') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <autocomplete @search="onTestingPressureSearch" :options="currentTestingPressure" v-model="model.testing_pressure"></autocomplete>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <autocomplete @search="onPedCategorySearch" :options="currentPedCategory" v-model="model.ped_category"></autocomplete>
                        </div>
                    </div>

                    <div v-if="showPAndIDNo">
                        <div class="col-lg-4 p-0">
                            <label>{{ $t('table.p_and_id_no') }}</label>
                        </div>
                        <div class="col-lg-12 p-0">
                            <multiselect v-model="selectedPAndIdNo"
                                :options="currentPAndIdNo"
                                :multiple="true"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPAndIdNoLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="p_and_id_no" track-by="p_and_id_no"
                                :selectLabel="''"
                                @search-change="onPAndIdNoSearch"
                                @input="updatePAndIdNo"
                            >
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div v-if="showCalibratedItem">
                        <div class="col-lg-4 p-0 mt-2">
                            <label>{{ $t('table.calibrated_items') }}</label>
                        </div>
                        <div class="col-lg-12 p-0">
                            <multiselect v-model="selectedCalibratedItem"
                                :options="currentCalibratedItem"
                                :multiple="true"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isCalibratedItemLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="info" track-by="id"
                                :selectLabel="''"
                                @search-change="onCalibratedItemSearch"
                                @input="updateCalibratedItem"
                            >
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.working_map_finalized') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.working_map_finalized" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.working_map_finalized == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.date_rd') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.date_rd"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.release_client') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.release_client" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.release_client == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.release_client_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.release_client_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test_done') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.pressure_test_done" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.release_authority') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.release_authority" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.release_authority == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.release_authority_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.release_authority_date"></flat-pickr>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.reinstallment_done') }}</label>
                        </div>
                         <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.reinstallment_done" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.reinstallment_done == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.reinstallment_done_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.reinstallment_done_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.reinstallment_done == 1">
                        <div class="col-lg-4">
                            <label>{{ $t('table.reinstallment_group') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedReinstallmentGroup"
                                :options="currentReinstallmentGroup"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isReinstallmentGroupLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onReinstallmentGroupSearch"
                                @input="updateReinstallmentGroup"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedReinstallmentGroup != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedReinstallmentGroup"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.third_party_participation') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.third_party_participation" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.flange_connection_control') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2" style="z-index: 0">
                            <toggle-button v-model="model.flange_connection_control" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>
                    <div class="row mb-3" v-if="model.flange_connection_control">
                        <div class="col-lg-4">
                            <label>{{ $t('table.flange_connection_control_date') }}</label>
                        </div>
                         <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.flange_connection_control_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.flange_connection_control_date && model.flange_connection_control">
                        <div class="col-lg-4">
                            <label>{{ $t('table.fc_team') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedWorkingGroup"
                                :options="currentWorkingGroup"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isWorkingGroupLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onWorkingGroupSearch"
                                @input="updateWorkingGroup"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWorkingGroup != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWorkingGroup"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.real_hours_used') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.real_hours_used">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remarks"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="model.revision_number" disabled>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="(getData.getFiles.length > 0 && hasFilesReadPermission) || hasFilesCreatePermission">
            <div class="row mt-2" v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
                <div class="col-lg-12">
                    <label>{{ $t('table.uploaded_files') }}</label>
                </div>
                <div class="col-lg-6" v-for="file in getData.getFiles" :key="file.id">
                    <div class="card p-2">
                        <div style="width: 100%; display: block">
                            <p 
                                class="float-left customLink" 
                                @click="onDownloadFile(file.id)" 
                                :title="file.file_name"
                            >
                                {{file.file_name}}
                            </p>
                            <p 
                                v-if="hasFilesDeletePermission"
                                class="float-right p-0 m-0"
                            >
                                <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile(file.id)"></i>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-2" v-if="hasFilesCreatePermission">
                <div class="col-lg-12">
                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label v-if="row && getData.getFiles.length > 0">{{ $t('table.upload_more_files') }}</label>
                            <label v-else>{{ $t('table.upload_files') }}</label>
                        </div>
                        <div class="col-lg-12">
                            <vue-dropzone class="dropzone" ref="document" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion1 variant="info">{{ $t('table.signature_pressure_test') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion1" accordion="my-accordion1" role="tabpanel">
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.client')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_pressure_test_client_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor1"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.company')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_pressure_test_company_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor2"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.other')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_pressure_test_other_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor3"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion5 variant="info">{{ $t('table.signature_mechanical_cleaning') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion5" accordion="my-accordion5" role="tabpanel">
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.client')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_mechanical_clean_client_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor4"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.company')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_mechanical_clean_company_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor5"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.other')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_mechanical_clean_other_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor6"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion2 variant="info">{{ $t('table.signature_reinstallment') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion2" accordion="my-accordion2" role="tabpanel">
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.client')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_reinstallment_client_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor7"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.company')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_reinstallment_company_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor8"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.other')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_reinstallment_other_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor9"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion8 variant="info">{{ $t('table.signature_blowing') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion8" accordion="my-accordion8" role="tabpanel">
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.client')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_blowing_client_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor10"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.company')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_blowing_company_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor11"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.other')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_blowing_other_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor12"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion3 variant="info">{{ $t('table.signature_chemical_cleaning') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion3" accordion="my-accordion3" role="tabpanel">
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.client')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_chemical_cleaning_client_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor13"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.company')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_chemical_clean_company_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor14"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.other')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_chemical_cleaning_other_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor15"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion6 variant="info">{{ $t('table.signature_passivation') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion6" accordion="my-accordion6" role="tabpanel">
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.client')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_passivation_client_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor16"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.company')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_passivation_company_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor17"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.other')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_passivation_other_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor18"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion7 variant="info">{{ $t('table.signature_inertization') }}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion7" accordion="my-accordion7" role="tabpanel">
                        <b-card-body>
                            <div class="row">
                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.client')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_inertization_client_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor19"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.company')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_inertization_company_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor20"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 text-center">
                                    <div class="row mb-3">
                                        <label class="col-lg-12">{{$t('table.other')}}</label>
                                        <div class="col-lg-12">
                                            <toggle-button v-model="model.signature_inertization_other_file_id" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColors.toggleColor21"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>

            <div v-if="row != null">
                <hr>
                <div v-if="hasBlindPermission">
                    <h3>{{ $t('table.blinds') }}</h3>
                    <data-table
                        :exportable="false" 
                        :search="false" 
                        title=""
                        :rows="getData.blindsData"
                        :columns="blindsColumnData"
                        @rowClickEdit="onEditBlindRow"
                        @rowClickDelete="onDeleteBlindRow"
                        @clickSpecificRow="onColumnClick"
                        @rowClickCheck="onClickCheckBlinds"
                        :paginate="false" 
                    >
                    </data-table>
                    <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddBlind" v-if="this.$store.getters.hasPermission(['project_blind'], ['create'])"></i>
                    <div class="clearfix"></div>
                    <hr>
                </div>

                <div v-if="hasRemovedItemPermission">
                    <h3>{{ $t('table.removed_items') }}</h3>
                    <data-table
                        :exportable="false" 
                        :search="false" 
                        title=""
                        :rows="getData.removedItemsData"
                        :columns="removedItemsColumnData"
                        @rowClickEdit="onEditRemovedItemRow"
                        @rowClickDelete="onDeleteRemovedItemRow"
                        @clickSpecificRow="onColumnClick"
                        @rowClickCheck="onClickCheckRemovedItems"
                        :paginate="false" 
                    >
                    </data-table>
                    <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddRemovedItem" v-if="this.$store.getters.hasPermission(['project_removed_item'], ['create'])"></i>
                    <div class="clearfix"></div>
                    <hr>
                </div>

                <div v-if="hasIsometricsPermission">
                    <h3>{{ $t('table.isometrics') }}</h3>
                    <data-table
                        :exportable="false" 
                        :search="false" 
                        title=""
                        :rows="getData.isometricsData"
                        :rowsColor="getData.rowColors"
                        :columns="isometricsColumnData"
                        @rowClickDelete="onDeleteIsometricRow"
                        @clickSpecificRow="onColumnClick"
                        :paginate="false" 
                    >
                    </data-table>
                    <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddIsometric" v-if="this.$store.getters.hasPermission(['project_isometric'], ['create'])"></i>
                    <div class="clearfix"></div>
                </div>

                <div v-if="hasWorkHistoryPermission">
                    <hr>
                    <h3>{{ $t('general.isometric_management.working_history_title') }}</h3>
                    <data-table
                        :exportable="false" 
                        :search="false"
                        title="" 
                        :rows="getData.workHistoryData"
                        :columns="historyColumnData"
                        @rowClickDelete="onDeleteWorkingRow"
                        @rowClickTask="onTaskWorkingRow"
                        @rowClickEdit="onEditWorkingRow"
                        :paginate="false" 
                    >
                    </data-table>
                    <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddWorkingHistory" v-if="this.$store.getters.hasPermission(['project_work_history'], ['create'])"></i>
                </div>
            </div>
        </b-modal>

        <blinds-modal 
            ref="blindsModal" 
            :title="actionTitleBlind" 
            :model.sync="blinds_model" 
            @onLoadTable="onLoadBlinds"
        />
        
        <removed-items-modal 
            ref="removedItemsModal" 
            :title="actionTitleRemoved" 
            :model.sync="removedItems_model" 
            @onLoadTable="onLoadRemovedItems"
        />

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="addIsometricModal" :title="actionTitleIsometric" size="md" @ok="saveIsometricAction" :ok-disabled="this.$store.state.ajax_in_progress" @hidden="onEditRow(row)">
            <div class="row">
                <div class="col-lg-3">
                    <label>{{ $t('table.isometric') }}</label>
                </div>
                <div class="col-lg-9">
                    <multiselect v-model="selectedIsometric"
                        :options="currentIsometrics"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isIsometricLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="info" track-by="id"
                        :selectLabel="''"
                        @search-change="onDrawingSearch"
                    >
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>
        </b-modal>

        <working-history-modal 
            ref="historyModal" 
            table="pressure_test" 
            :title="actionTitleWork" 
            :model.sync="working_model" 
            @onLoadTable="onLoadWorkHistoryTable"
        />

        <task-modal 
            ref="taskModal"
            :specialInputs.sync="specialInputs"
            :title="actionTitleTask" 
            :model.sync="task_model" 
            @loadTable="onLoadTable" 
        />

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ delete_message }}
        </confirm-dialog>

        <confirm-dialog ref="deleteBlindModal" :title="actionTitleBlind" @buttonClick="deleteBlindAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>

        <confirm-dialog ref="deleteRemovedItemModal" :title="actionTitleRemoved" @buttonClick="deleteRemovedItemAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>

        <confirm-dialog ref="deleteIsometricModal" :title="actionTitleIsometric" @buttonClick="deleteIsometricAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>

        <confirm-dialog ref="deleteModalWorking" :title="actionTitleDelete" @buttonClick="deleteActionWorking">
            {{ delete_message }}
        </confirm-dialog>

        <confirm-dialog ref="pdfModal" :title="actionTitlePdf" @buttonClick="onDownloadPDF">
            <p>{{ download_pdf_message }}</p>
            <span class="mr-1">{{ $t('table.signatures') }}</span> <toggle-button v-model="model.not_applicable" :sync="true" :width="120" :value="false" :labels="{checked: $t('table.not_applicable'), unchecked: $t('table.applicable')}" :color="{checked: '#ff471a'}" class="m-0"/>
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';
import Autocomplete from '@/components/global/miscellaneous/Autocomplete.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Multiselect from 'vue-multiselect';
import WorkingHistoryModal from '@/components/global/modals/WorkingHistoryModal.vue';
import BlindsModal from '@/components/global/modals/BlindsModal.vue';
import RemovedItemsModal from '@/components/global/modals/RemovedItemsModal.vue';
import TaskModal from '@/components/global/modals/TaskModal.vue';

import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';

export default {
    name: 'pressure_test_planning',
    components: {
        DataTable,
        ConfirmDialog,
        Multiselect,
        Autocomplete,
        flatPickr,
        WorkingHistoryModal,
        BlindsModal,
        RemovedItemsModal,
        TaskModal,
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: '',
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.pressure_test_planning.title'),
                    active: true
                }
            ],
            tableName: 'pressuretest',
            tableNameTranslated: Vue.i18n.translate('general.pressure_test_planning.title_modal'),
            row: null,
            rowHistory: null,
            rowIsometric: null,
            rowBlind: null,
            rowRemovedItem: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',

            actionTitle: '',
            actionTitleBlind: '',
            actionTitleRemoved: '',
            actionTitleIsometric: '',
            actionTitleWork: '',
            actionTitleTask: '',
            actionTitleDelete: '',

            actionTitlePdf: '',
            delete_message: '',
            specialInputs: [],
            download_pdf_message: '',
            pdfType: null,

            hasBlindPermission: false,
            hasRemovedItemPermission: false,
            hasIsometricsPermission: false,
            hasWorkHistoryPermission: false,

            selectedPressureTestTeam: null,
            currentPressureTestTeam: [],
            isPressureTestTeamLoading: false,

            selectedPressureTestUser: null,
            currentPressureTestUser: [],
            isPressureTestUserLoading: false,

            currentPAndIdNo: [],
            selectedPAndIdNo: [],
            isPAndIdNoLoading: false,
            showPAndIDNo: false,

            currentCalibratedItem: [],
            selectedCalibratedItem: [],
            isCalibratedItemLoading: false,
            showCalibratedItem: false,

            selectedReinstallmentGroup: null,
            currentReinstallmentGroup: [],
            isReinstallmentGroupLoading: false,

            selectedWorkingGroup: null,
            currentWorkingGroup: [],
            isWorkingGroupLoading: false,

            currentTestingMedium: [],
            isTestingMediumLoading: false,

            currentTestingPressure: [],
            isTestingPressureLoading: false,

            currentPedCategory: [],

            selectedIsometric: null,
            currentIsometrics: [],
            isIsometricLoading: false,

            hasFilesReadPermission: false,
            hasFilesCreatePermission: false,
            hasFilesDeletePermission: false,

            //check if already opened
            already_opened_warning: false,
            //end check if already opened

            file_id: null,
            isFileDelete: false,

            dropzoneOptions: {
                url: '/',
                thumbnailWidth: 150,
                addRemoveLinks: true,
                autoProcessQueue: false,
                uploadMultiple: true,
                dictDefaultMessage: '<i class="fa fa-cloud-upload"></i>' + ' ' + Vue.i18n.translate('table.upload_files'),
                maxFiles: 3,
            },
            getData: {
                rowData: [],
                getFiles: [],
                rowColors: [],
                blindsData: [],
                removedItemsData: [],
                workHistoryData: [],
                isometricsData: [],
            },
            toggleColors: {
                toggleColor1: '#5373d4',
                toggleColor2: '#5373d4',
                toggleColor3: '#5373d4',
                toggleColor4: '#5373d4',
                toggleColor5: '#5373d4',
                toggleColor6: '#5373d4',
                toggleColor7: '#5373d4',
                toggleColor8: '#5373d4',
                toggleColor9: '#5373d4',
                toggleColor10: '#5373d4',
                toggleColor11: '#5373d4',
                toggleColor12: '#5373d4',
                toggleColor13: '#5373d4',
                toggleColor14: '#5373d4',
                toggleColor15: '#5373d4',
                toggleColor16: '#5373d4',
                toggleColor17: '#5373d4',
                toggleColor18: '#5373d4',
                toggleColor19: '#5373d4',
                toggleColor20: '#5373d4',
                toggleColor21: '#5373d4',
            },
            model: {
                not_applicable: false,
                revision_number: null,
                test_circuit_no: null,
                pressure_test_team_id: null,
                pressure_test_user_id: null,
                all_works_finished: null,
                testing_medium: null,
                testing_pressure: null,
                ped_category: null,
                working_map_finalized: null,
                date_rd: null,
                release_client : null,
                release_client_date: null,
                pressure_test_done: null,
                release_authority: null,
                release_authority_date: null,
                pressure_test_date: null,
                reinstallment_done: null,
                reinstallment_done_date: null,
                reinstallment_group_id: null,
                third_party_participation: null,
                flange_connection_control: null,
                real_hours_used: null,
                remarks: null,
                delayed: null,
                flange_connection_control_date: null,
                working_group_id: null,
                signature_pressure_test_client_file_id: null,
                signature_pressure_test_company_file_id: null,
                signature_pressure_test_other_file_id: null,
                signature_reinstallment_client_file_id: null,
                signature_reinstallment_company_file_id: null,
                signature_reinstallment_other_file_id: null,
                signature_chemical_cleaning_client_file_id: null,
                signature_chemical_clean_company_file_id: null,
                signature_chemical_cleaning_other_file_id: null,
                signature_mechanical_clean_client_file_id: null,
                signature_mechanical_clean_company_file_id: null,
                signature_mechanical_clean_other_file_id: null,
                signature_passivation_client_file_id: null,
                signature_passivation_company_file_id: null,
                signature_passivation_other_file_id: null,
                signature_inertization_client_file_id: null,
                signature_inertization_company_file_id: null,
                signature_inertization_other_file_id: null,
                signature_blowing_client_file_id: null,
                signature_blowing_company_file_id: null,
                signature_blowing_other_file_id: null,
                file: null,
            },
            blinds_model: {
                id: null,
				project_id: null,
				pressure_test_id: null,
				project_setting_id: null,
				project_setting_description: null,
				standard: null,
				size: null,
				rating: null,
				qty: null,
				unit: null,
				installed: null,
				removed: null,
				all_installed: false,
				all_removed: false,
				remark: null,
            },
            removedItems_model: {
                id: null,
				project_id: null,
				pressure_test_id: null,
				project_setting_id: null,
				project_setting_description: null,
				id_number: null,
				standard: null,
				size: null,
				rating: null,
				qty: null,
				unit: null,
				installed: null,
				removed: null,
				all_installed: false,
				all_removed: false,
				remark: null,
            },
            working_model: {
                id: null,
                team_id: null,
                user_id: null,
                date: null,
                remark: null,
                team: null,
                user: null,
                project_setting: null,
            },
            task_model: {
                id: null,
                loggedUser: null,
                task_no: null,
                task_title: null,
                by_user_id: null,
                to_company_id: null,
                to_user_id: null,
                to_team_id: null,
                discipline_id: null,
                latest_date: null,
                exact_date: null,
                exact_time: null,
                importancy: null,
                urgency: null,
                status: null,
                closed: null,
                selectedUser: null,
                selectedDiscipline: null,
                selectedToCompany: null,
                selectedToTeam: null,
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '170px',
                    showDeleteButton: true,
                    showEditButton: true,
                    showRevisionButton: true,
                    showPDF: true,
                },
                {
                    label: Vue.i18n.translate('table.test_circuit_no'),
                    field: 'test_circuit_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.delayed'),
                    field: 'delayed',
                    numeric: false,
                    html: false,
                    showAsCheckRed: true
                },
                {
                    label: Vue.i18n.translate('table.all_works_finished'),
                    field: 'all_works_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                },
                {
                    label: Vue.i18n.translate('table.testing_medium'),
                    field: 'testing_medium',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.testing_pressure'),
                    field: 'testing_pressure',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.working_map_finalized'),
                    field: 'working_map_finalized',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.release_client'),
                    field: 'release_client',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.release_authority'),
                    field: 'release_authority',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.pressure_test_done'),
                    field: 'pressure_test_done',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.pressure_test_group'),
                    field: 'pressure_test_team.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pressure_test_date'),
                    field: 'pressure_test_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.reinstallment_done'),
                    field: 'reinstallment_done',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.reinstallment_done_date'),
                    field: 'reinstallment_done_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.reinstallment_group'),
                    field: 'reinstallment_group.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.third_party_participation'),
                    field: 'third_party_participation',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.flange_connection_control'),
                    field: 'flange_connection_control',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.flange_connection_control_date'),
                    field: 'flange_connection_control_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.remarks'),
                    field: 'remarks',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ped_category'),
                    field: 'ped_category',
                    numeric: false,
                    html: false,
                },
                {
					label: Vue.i18n.translate('table.revision_date'),
					field: 'revision_date',
					numeric: false,
					html: false,
				},
                {
					label: Vue.i18n.translate('table.revision_number'),
					field: 'revision_number',
					numeric: false,
					html: false,
				}
            ],
            blindsColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    showDeleteButton: true,
                    showEditButton: true,
                    width: '90px',
                },
                {
                    label: Vue.i18n.translate('table.description'),
                    field: 'project_setting_description.info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.size'),
                    field: 'size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.rating'),
                    field: 'rating',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.quantity'),
                    field: 'qty',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.unit'),
                    field: 'unitV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.installed'),
                    field: 'installed',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.removed'),
                    field: 'removed',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.all_installed'),
                    field: 'all_installed',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.all_removed'),
                    field: 'all_removed',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                }
            ],
            removedItemsColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    showDeleteButton: true,
                    width: '90px',
                },
                {
                    label: Vue.i18n.translate('table.description'),
                    field: 'project_setting_description.info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.id_number'),
                    field: 'id_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.size'),
                    field: 'size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.rating'),
                    field: 'rating',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.quantity'),
                    field: 'qty',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.unit'),
                    field: 'unitV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.installed'),
                    field: 'installed',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.removed'),
                    field: 'removed',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.all_installed'),
                    field: 'all_installed',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.all_removed'),
                    field: 'all_removed',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                }
            ],
            isometricsColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '45px',
                    showDeleteButton: true,
                },
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'line.area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.field_area'),
                    field: 'field_area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.serial_no'),
                    field: 'line.serial_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_number'),
                    field: 'line.line_number',
                    numeric: false,
                    html: false,
                    clickable: true,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.size'),
                    field: 'line.line_size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'work_history_progress_status',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.delayed'),
                    field: 'delayed',
                    numeric: false,
                    html: false,
                    showAsCheckRed: true,
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.priority'),
                    field: 'priority',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.test_circuit_no'),
                    field: 'line.test_circuit_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.tie_in_no'),
                    field: 'line.tie_in.tie_in_nr',
                    numeric: false,
                    html: false,
                    clickable: true,
                },
                {
                    label: Vue.i18n.translate('table.testing_med'),
                    field: 'line.testing_med',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.testing_press'),
                    field: 'line.testing_press',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ped_category'),
                    field: 'line.ped_category',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.p_and_id_no'),
                    field: 'line.p_and_id_no',
                    numeric: false,
                    html: false,
                },
            ],
            historyColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '120px',
                    showDeleteButton: true,
                    showEditButton: true,
                    showTaskButton: true,
                }, {
                    label: Vue.i18n.translate('table.working_group'),
                    field: 'team.name',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.date'),
                    width: '105px',
                    field: 'date',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'project_setting.info',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.remark'),
                    field: 'remark',
                    numeric: false,
                    html: false,
                },
            ],
        }
    },
    mounted() {
        if (this.$store.state.go_back_url == 'line_list' || this.$store.state.go_back_url == 'tieinmanagement') {
            this.onLoadTable().then(res => {
                let row = this.getData.rowData.find(r => r.id == this.$store.state.go_back_data_list[1]);
                if(row != null) {
                    this.onEditRow(row);
                }

                this.$store.state.go_back_data_list[0] = null;
                this.$store.state.go_back_data_list[1] = null;
            });
        } else {
            this.onLoadTable();
            this.$store.state.go_back_data_list[0] = null;
            this.$store.state.go_back_data_list[1] = null;
        }

        this.$store.state.go_back_url = null;

        this.hasBlindPermission       = this.$store.getters.hasPermission(['project_blind'], ['read']);
        this.hasRemovedItemPermission = this.$store.getters.hasPermission(['project_removed_item'], ['read']);
        this.hasIsometricsPermission  = this.$store.getters.hasPermission(['project_isometric'], ['read']);
        this.hasWorkHistoryPermission = this.$store.getters.hasPermission(['project_work_history'], ['read']);

        this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
        this.hasFilesCreatePermission = this.$store.getters.hasPermission(['files'], ['create']);
        this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);
    },
    watch: {
        model: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                this.model.all_works_finished        = Boolean(newVal.all_works_finished);
                this.model.working_map_finalized     = Boolean(newVal.working_map_finalized);
                this.model.release_client            = Boolean(newVal.release_client);
                this.model.pressure_test_done        = Boolean(newVal.pressure_test_done);
                this.model.release_authority         = Boolean(newVal.release_authority);
                this.model.reinstallment_done        = Boolean(newVal.reinstallment_done);
                this.model.flange_connection_control = Boolean(newVal.flange_connection_control);
                this.model.third_party_participation = Boolean(newVal.third_party_participation);
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        async onLoadTable () {
            return new Promise((resolve, reject) => {
                let data = http.route(this.tableName + '?project_id='+this.$route.params.id+'&filters[parent_pressure_test_id]=null&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
                data.then(response => {
                    if (!response.isError) {
                        this.perPage     = response.pagination.limit;
                        this.rowsCount   = response.pagination.totalEntries;
                        this.currentPage = response.pagination.currentPage;
                        this.pageCount   = response.pagination.totalPages;
                        var data = response.data;
                            data.forEach(field => {
                            if (field.pressure_test_team_id == null) {
                                field.pressure_test_team = { 'name': '' };
                            }

                            if (field.reinstallment_group_id == null) {
                                field.reinstallment_group = { 'name': '' };
                            }

                            if (field.working_group_id == null) {
                                field.working_group = { 'name': '' };
                            }
                        });
                        this.getData.rowData = data;
                        this.tableLoaded = true;
                        this.breadcrumbItems[1].text = Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                    resolve();
                });
            });
        },
        clearSearches () {
            this.currentPressureTestTeam   = [];
            this.currentPressureTestUser   = [];
            this.currentReinstallmentGroup = [];
            this.currentWorkingGroup       = [];
            this.currentIsometrics         = [];

            this.selectedPressureTestTeam   = null;
            this.selectedPressureTestUser   = null;
            this.selectedReinstallmentGroup = null;
            this.selectedWorkingGroup       = null;
            this.selectedIsometric          = null;

            //Files
            this.getData.getFiles = [];
            this.$nextTick(() => {
                if (typeof this.$refs.document != 'undefined') {
                    this.$refs.document.removeAllFiles();
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();
            
            this.toggleColors.toggleColor1 = '#5373d4';
            this.toggleColors.toggleColor2 = '#5373d4';
            this.toggleColors.toggleColor3 = '#5373d4';
            this.toggleColors.toggleColor4 = '#5373d4';
            this.toggleColors.toggleColor5 = '#5373d4';
            this.toggleColors.toggleColor6 = '#5373d4';
            this.toggleColors.toggleColor7 = '#5373d4';
            this.toggleColors.toggleColor8 = '#5373d4';
            this.toggleColors.toggleColor9 = '#5373d4';
            this.toggleColors.toggleColor10 = '#5373d4';
            this.toggleColors.toggleColor11 = '#5373d4';
            this.toggleColors.toggleColor12 = '#5373d4';
            this.toggleColors.toggleColor13 = '#5373d4';
            this.toggleColors.toggleColor14 = '#5373d4';
            this.toggleColors.toggleColor15 = '#5373d4';
            this.toggleColors.toggleColor16 = '#5373d4';
            this.toggleColors.toggleColor17 = '#5373d4';
            this.toggleColors.toggleColor18 = '#5373d4';
            this.toggleColors.toggleColor19 = '#5373d4';
            this.toggleColors.toggleColor20 = '#5373d4';
            this.toggleColors.toggleColor21 = '#5373d4';
            this.model.revision_number = null;
            this.model.pressure_test_team_id = null;
            this.model.pressure_test_user_id = null;
            this.model.all_works_finished = null;
            this.model.testing_medium = null;
            this.model.testing_pressure = null;
            this.model.working_map_finalized = null;
            this.model.date_rd = null;
            this.model.release_client = null;
            this.model.release_client_date = null;
            this.model.pressure_test_done = null;
            this.model.release_authority = null;
            this.model.release_authority_date = null;
            this.model.pressure_test_date = null;
            this.model.reinstallment_done = null;
            this.model.reinstallment_done_date = null;
            this.model.reinstallment_group_id = null;
            this.model.third_party_participation = null;
            this.model.flange_connection_control = null;
            this.model.real_hours_used = null;
            this.model.remarks = null;
            this.model.delayed = null;
            this.model.flange_connection_control_date = null;
            this.model.working_group_id = null;
            this.model.signature_pressure_test_client_file_id = null;
            this.model.signature_pressure_test_company_file_id = null;
            this.model.signature_pressure_test_other_file_id = null;
            this.model.signature_reinstallment_client_file_id = null;
            this.model.signature_reinstallment_company_file_id = null;
            this.model.signature_reinstallment_other_file_id = null;
            this.model.signature_chemical_cleaning_client_file_id = null;
            this.model.signature_chemical_clean_company_file_id = null;
            this.model.signature_chemical_cleaning_other_file_id = null;
            this.model.signature_mechanical_clean_client_file_id = null;
            this.model.signature_mechanical_clean_company_file_id = null;
            this.model.signature_mechanical_clean_other_file_id = null;
            this.model.signature_passivation_client_file_id = null;
            this.model.signature_passivation_company_file_id = null;
            this.model.signature_passivation_other_file_id = null;
            this.model.signature_inertization_client_file_id = null;
            this.model.signature_inertization_company_file_id = null;
            this.model.signature_inertization_other_file_id = null;
            this.model.signature_blowing_client_file_id = null;
            this.model.signature_blowing_company_file_id = null;
            this.model.signature_blowing_other_file_id = null;
            this.model.ped_category = null;
            this.model.p_and_id_no = null;
            this.model.test_circuit_no = null;

            this.selectedPAndIdNo = [];
            this.selectedCalibratedItem = [];
            this.currentPAndIdNo = [];
            this.currentCalibratedItem = [];
            this.showPAndIDNo = true;
            this.showCalibratedItem = true;

            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.clearSearches();

            if (this.hasFilesReadPermission) {
                this.onViewFiles(row.id);
            }
            
            this.onLoadLines();
            this.onLoadCalibratedItems();

            this.getData.blindsData = [];
            if (this.hasBlindPermission) {
                this.onLoadBlinds();
            }

            this.getData.removedItemsData = [];
            if (this.hasRemovedItemPermission) {
                this.onLoadRemovedItems();
            }

            this.getData.isometricsData = [];
            if (this.hasIsometricsPermission) {
                this.onLoadIsometrics();
            }

            this.getData.workHistoryData = [];
            if (this.hasWorkHistoryPermission) {
                this.onLoadWorkHistoryTable();
            }

            //check if already opened
            this.already_opened_warning = false;
            let data = {
                id: this.row.id,
                object_is_opened_now: 1,
            };
            http.route(this.tableName + '/' + this.row.id).patch(data, true).then(response => {
                if (response.isError == false) {
                    if (typeof response.data != 'undefined') {
                        if (response.data.opened_by != this.$store.state.user.user.id) {
                            this.warnMsg(Vue.i18n.translate('misc.document_is_open'));                      
                        }
                    }
                }
            });
            //end check if already opened

            this.onViewFiles(row.id);
            this.model.revision_number                = this.row.revision_number;
            this.model.line_id                        = this.row.line_id;
            this.model.pressure_test_team_id          = this.row.pressure_test_team_id;
            this.model.pressure_test_user_id          = this.row.pressure_test_user_id;
            this.model.all_works_finished             = this.row.all_works_finished;
            this.model.testing_medium                 = this.row.testing_medium;
            this.model.testing_pressure               = this.row.testing_pressure;
            this.model.ped_category                   = this.row.ped_category;
            this.model.p_and_id_no                    = this.row.p_and_id_no;
            this.model.test_circuit_no                = this.row.test_circuit_no;
            this.model.working_map_finalized          = this.row.working_map_finalized;
            this.model.date_rd                        = this.row.date_rd;
            this.model.delayed                        = this.row.delayed;
            this.model.real_hours_used                = this.row.real_hours_used;
            this.model.remarks                        = this.row.remarks;
            this.model.release_client                 = this.row.release_client;
            this.model.release_client_date            = this.row.release_client_date;
            this.model.pressure_test_done             = this.row.pressure_test_done;
            this.model.release_authority              = this.row.release_authority;
            this.model.release_authority_date         = this.row.release_authority_date;
            this.model.pressure_test_date             = this.row.pressure_test_date;
            this.model.reinstallment_done             = this.row.reinstallment_done;
            this.model.reinstallment_done_date        = this.row.reinstallment_done_date;
            this.model.reinstallment_group_id         = this.row.reinstallment_group_id;
            this.model.third_party_participation      = this.row.third_party_participation;
            this.model.flange_connection_control      = this.row.flange_connection_control;
            this.model.remark                         = this.row.remark;
            this.model.flange_connection_control_date = this.row.flange_connection_control_date;
            this.model.working_group_id               = this.row.working_group_id;

            this.selectedPressureTestTeam   = (this.row.pressure_test_team != null && this.row.pressure_test_team.name != 'undefined' && this.row.pressure_test_team.name != '') ? this.row.pressure_test_team : null;
            this.selectedPressureTestUser   = this.row.pressure_test_user;
            this.selectedReinstallmentGroup = (this.row.reinstallment_group != null && this.row.reinstallment_group.name != 'undefined' && this.row.reinstallment_group.name != '') ? this.row.reinstallment_group : null;
            this.selectedWorkingGroup       = (this.row.working_group != null && this.row.working_group.name != 'undefined' && this.row.working_group.name != '') ? this.row.working_group : null;

            this.model.signature_pressure_test_client_file_id = Boolean(this.row.signature_pressure_test_client_file_id);
            this.model.signature_pressure_test_company_file_id = Boolean(this.row.signature_pressure_test_company_file_id);
            this.model.signature_pressure_test_other_file_id = Boolean(this.row.signature_pressure_test_other_file_id);

            this.model.signature_mechanical_clean_client_file_id = Boolean(this.row.signature_mechanical_clean_client_file_id);
            this.model.signature_mechanical_clean_company_file_id = Boolean(this.row.signature_mechanical_clean_company_file_id);
            this.model.signature_mechanical_clean_other_file_id = Boolean(this.row.signature_mechanical_clean_other_file_id);

            this.model.signature_reinstallment_client_file_id = Boolean(this.row.signature_reinstallment_client_file_id);
            this.model.signature_reinstallment_company_file_id = Boolean(this.row.signature_reinstallment_company_file_id);
            this.model.signature_reinstallment_other_file_id = Boolean(this.row.signature_reinstallment_other_file_id);

            this.model.signature_blowing_client_file_id = Boolean(this.row.signature_blowing_client_file_id);
            this.model.signature_blowing_company_file_id = Boolean(this.row.signature_blowing_company_file_id);
            this.model.signature_blowing_other_file_id = Boolean(this.row.signature_blowing_other_file_id);

            this.model.signature_chemical_cleaning_client_file_id = Boolean(this.row.signature_chemical_cleaning_client_file_id);
            this.model.signature_chemical_clean_company_file_id = Boolean(this.row.signature_chemical_clean_company_file_id);
            this.model.signature_chemical_cleaning_other_file_id = Boolean(this.row.signature_chemical_cleaning_other_file_id);

            this.model.signature_passivation_client_file_id = Boolean(this.row.signature_passivation_client_file_id);
            this.model.signature_passivation_company_file_id = Boolean(this.row.signature_passivation_company_file_id);
            this.model.signature_passivation_other_file_id = Boolean(this.row.signature_passivation_other_file_id);

            this.model.signature_inertization_client_file_id = Boolean(this.row.signature_inertization_client_file_id);
            this.model.signature_inertization_company_file_id = Boolean(this.row.signature_inertization_company_file_id);
            this.model.signature_inertization_other_file_id = Boolean(this.row.signature_inertization_other_file_id);

            this.toggleColors.toggleColor1 = ((this.$store.state.user.user.id == this.row.signature_pressure_test_client_file_id) || this.row.signature_pressure_test_client_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor2 = ((this.$store.state.user.user.id == this.row.signature_pressure_test_company_file_id) || this.row.signature_pressure_test_company_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor3 = ((this.$store.state.user.user.id == this.row.signature_pressure_test_other_file_id) || this.row.signature_pressure_test_other_file_id == null) ? '#5373d4' : '#75C791';

            this.toggleColors.toggleColor4 = ((this.$store.state.user.user.id == this.row.signature_mechanical_clean_client_file_id) || this.row.signature_mechanical_clean_client_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor5 = ((this.$store.state.user.user.id == this.row.signature_mechanical_clean_company_file_id) || this.row.signature_mechanical_clean_company_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor6 = ((this.$store.state.user.user.id == this.row.signature_mechanical_clean_other_file_id) || this.row.signature_mechanical_clean_other_file_id == null) ? '#5373d4' : '#75C791';

            this.toggleColors.toggleColor7 = ((this.$store.state.user.user.id == this.row.signature_reinstallment_client_file_id) || this.row.signature_reinstallment_client_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor8 = ((this.$store.state.user.user.id == this.row.signature_reinstallment_company_file_id) || this.row.signature_reinstallment_company_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor9 = ((this.$store.state.user.user.id == this.row.signature_reinstallment_other_file_id) || this.row.signature_reinstallment_other_file_id == null) ? '#5373d4' : '#75C791';

            this.toggleColors.toggleColor10 = ((this.$store.state.user.user.id == this.row.signature_blowing_client_file_id) || this.row.signature_blowing_client_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor11 = ((this.$store.state.user.user.id == this.row.signature_blowing_company_file_id) || this.row.signature_blowing_company_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor12 = ((this.$store.state.user.user.id == this.row.signature_blowing_other_file_id) || this.row.signature_blowing_other_file_id == null) ? '#5373d4' : '#75C791';

            this.toggleColors.toggleColor13 = ((this.$store.state.user.user.id == this.row.signature_chemical_cleaning_client_file_id) || this.row.signature_chemical_cleaning_client_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor14 = ((this.$store.state.user.user.id == this.row.signature_chemical_clean_company_file_id) || this.row.signature_chemical_clean_company_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor15 = ((this.$store.state.user.user.id == this.row.signature_chemical_cleaning_other_file_id) || this.row.signature_chemical_cleaning_other_file_id == null) ? '#5373d4' : '#75C791';

            this.toggleColors.toggleColor16 = ((this.$store.state.user.user.id == this.row.signature_passivation_client_file_id) || this.row.signature_passivation_client_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor17 = ((this.$store.state.user.user.id == this.row.signature_passivation_company_file_id) || this.row.signature_passivation_company_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor18 = ((this.$store.state.user.user.id == this.row.signature_passivation_other_file_id) || this.row.signature_passivation_other_file_id == null) ? '#5373d4' : '#75C791';

            this.toggleColors.toggleColor19 = ((this.$store.state.user.user.id == this.row.signature_inertization_client_file_id) || this.row.signature_inertization_client_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor20 = ((this.$store.state.user.user.id == this.row.signature_inertization_company_file_id) || this.row.signature_inertization_company_file_id == null) ? '#5373d4' : '#75C791';
            this.toggleColors.toggleColor21 = ((this.$store.state.user.user.id == this.row.signature_inertization_other_file_id) || this.row.signature_inertization_other_file_id == null) ? '#5373d4' : '#75C791';

            this.$refs.saveModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id:                                 this.$route.params.id,
                pressure_test_team_id:                      this.model.pressure_test_team_id,
                pressure_test_user_id:                      this.model.pressure_test_user_id,
                all_works_finished:                         this.model.all_works_finished,
                testing_medium:                             this.model.testing_medium,
                testing_pressure:                           this.model.testing_pressure,
                p_and_id_no:                                this.model.p_and_id_no,
                ped_category:                               this.model.ped_category,
                test_circuit_no:                            this.model.test_circuit_no,
                working_map_finalized:                      this.model.working_map_finalized,
                date_rd:                                    this.model.date_rd,
                release_client:                             this.model.release_client,
                release_client_date:                        this.model.release_client_date,
                pressure_test_done:                         this.model.pressure_test_done,
                release_authority:                          this.model.release_authority,
                release_authority_date:                     this.model.release_authority_date,
                pressure_test_date:                         this.model.pressure_test_date,
                reinstallment_done:                         this.model.reinstallment_done,
                reinstallment_done_date:                    this.model.reinstallment_done_date,
                reinstallment_group_id:                     this.model.reinstallment_group_id,
                third_party_participation:                  this.model.third_party_participation,
                flange_connection_control:                  this.model.flange_connection_control,
                remarks:                                    this.model.remarks,
                flange_connection_control_date:             this.model.flange_connection_control_date,
                working_group_id:                           this.model.working_group_id,
                signature_pressure_test_client_file_id:     this.model.signature_pressure_test_client_file_id,
                signature_pressure_test_company_file_id:    this.model.signature_pressure_test_company_file_id,
                signature_pressure_test_other_file_id:      this.model.signature_pressure_test_other_file_id,
                signature_reinstallment_client_file_id:     this.model.signature_reinstallment_client_file_id,
                signature_reinstallment_company_file_id:    this.model.signature_reinstallment_company_file_id,
                signature_reinstallment_other_file_id:      this.model.signature_reinstallment_other_file_id,
                signature_chemical_cleaning_client_file_id: this.model.signature_chemical_cleaning_client_file_id,
                signature_chemical_clean_company_file_id:   this.model.signature_chemical_clean_company_file_id,
                signature_chemical_cleaning_other_file_id:  this.model.signature_chemical_cleaning_other_file_id,
                signature_mechanical_clean_client_file_id:  this.model.signature_mechanical_clean_client_file_id,
                signature_mechanical_clean_company_file_id: this.model.signature_mechanical_clean_company_file_id,
                signature_mechanical_clean_other_file_id:   this.model.signature_mechanical_clean_other_file_id,
                signature_passivation_client_file_id:       this.model.signature_passivation_client_file_id,
                signature_passivation_company_file_id:      this.model.signature_passivation_company_file_id,
                signature_passivation_other_file_id:        this.model.signature_passivation_other_file_id,
                signature_inertization_client_file_id:      this.model.signature_inertization_client_file_id,
                signature_inertization_company_file_id:     this.model.signature_inertization_company_file_id,
                signature_inertization_other_file_id:       this.model.signature_inertization_other_file_id,
                signature_blowing_client_file_id:           this.model.signature_blowing_client_file_id,
                signature_blowing_company_file_id:          this.model.signature_blowing_company_file_id,
                signature_blowing_other_file_id:            this.model.signature_blowing_other_file_id,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row) {
                //check if already opened
                put_data['already_opened_warning'] = this.already_opened_warning;
                //end check if already opened

                http.route(this.tableName + '/' + this.row.id).patch(put_data, true).then(response => {
                    if (!response.isError) {
                        this.saveLines(this.row.id);
                        this.saveCalibratedItems(this.row.id);
                        this.uploadDocuments(this.row.id);
                        this.onLoadTable(this.row.id);
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$refs.saveModal.hide();
                        //check if already opened
                        this.already_opened_warning = false;
                        //end check if already opened
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            //check if already opened
                            if (response.errorMessage[key] == 'misc.document_already_opened') {
                                this.already_opened_warning = true;
                                this.errorMsg(Vue.i18n.translate('misc.document_already_opened'));
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                            //end check if already opened
                        });
                    }
                });
            } else {
                http.route(this.tableName).post(put_data, true).then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.saveLines(response.data.id);
                        this.saveCalibratedItems(response.data.id);

                        this.uploadDocuments(response.data.id);
                        this.$refs.saveModal.hide();
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
            }
        },
        uploadDocuments (id) {
            if (this.hasFilesCreatePermission && typeof this.$refs.document != 'undefined') {
                var file = this.$refs.document.getQueuedFiles();
                for (let order = 0; order < file.length; order++) {
                    var formData = new FormData();
                    formData.append('file', file[order]);
                    formData.append('type', 'pressure_test');
                    formData.append('pressure_test_id', id);
                    formData.append('project_id', this.$route.params.id);
                    let data = http.route('file').post(
                        formData,
                            {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.successMsg(Vue.i18n.translate('messages.file_uploaded'));
                            this.onLoadTable();
                        }
                    });
                }
            }
        },
        onViewFiles (id) {
            this.getData.getFiles.length = 0;
            let data = http.route('file?get_all=1&filters[pressure_test_id]=' + id).get();
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.getData.getFiles = response.data;
                }
            });
        },
        onDownloadFile (id) {
            let data = http.route('file/' + id).get(
            {
                export_pdf: 1
            }, true);
            data.then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                    let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                } else {
                    this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                }
            });
        },
        onDeleteRow (row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.delete_message = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    let data = http.route('file/' + this.file_id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.onLoadTable();
                            this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            this.file_id = null;
                            this.$refs.saveModal.hide();
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                } else if (this.isFileDelete == false) {
                    this.selectedPAndIdNo = [];
                    this.selectedCalibratedItem = [];
                    
                    this.deleteExisting().then(res => {
                        let data = http.route(this.tableName + '/' + this.row.id).delete();
                        data.then(response => {
                            if (!response.isError) {
                                if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                                    this.currentPage = this.currentPage - 1;
                                }

                                this.onLoadTable();
                                this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                            } else {
                                this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                            }
                        });
                    });
                }
            }
            this.$refs.deleteModal.hide();
        },
        async deleteExisting () {
            await this.saveLines(this.row.id);
            await this.saveCalibratedItems(this.row.id);
        },
        modalHidden () {
            this.showPAndIDNo = false;
            this.showCalibratedItem = false;

            //check if already opened
            this.already_opened_warning = false;
            if (this.row != null) {
                let data = {
                    id: this.row.id,
                    object_is_opened_now: 0,
                };
                http.route(this.tableName + '/' + this.row.id).patch(data, true);
            }
            //end check if already opened
        },
        onPDF (type, row) {
            this.pdfType = type;
            switch(this.pdfType) {
                case 'table':   
                    this.actionTitlePdf = Vue.i18n.translate('modal.general.download_pdf');
                    this.download_pdf_message = Vue.i18n.translate('messages.download_pdf');
                    break;
                case 'button':
                    this.actionTitlePdf = Vue.i18n.translate('modal.general.download_pdfs');
                    this.download_pdf_message = Vue.i18n.translate('messages.download_pdfs');
                    break;
            }
            this.row = row;
            this.model.not_applicable = false;
            this.$refs.pdfModal.show();
        },
        onDownloadPDF (button) {
            if (button == 1) {
                let not_applicable = (this.model.not_applicable == true) ? 1 : 0;
                switch(this.pdfType) {
                    case 'table':
                        let data = http.route(this.tableName + '/' + this.row.id).get(
                        {
                            export_pdf: 1,
                            not_applicable: not_applicable
                        }, true);
                        data.then(response => {
                            if (!response.isError) {
                                let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                                    if (typeof res == 'undefined') {
                                        miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                                    } else {
                                        Object.keys(res.errorMessage).forEach(key => {
                                            this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                        });
                                    }
                                });
                            } else {
                                miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                            }
                        });
                        break;
                    case 'button':
                        this.getData.rowData.forEach(row => {
                            let data = http.route(this.tableName + '/' + row.id).get(
                            {
                                export_pdf: 1,
                                not_applicable: not_applicable
                            }, true);
                            data.then(response => {
                                if (!response.isError) {
                                    let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                                        if (typeof res == 'undefined') {
                                            miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                                        } else {
                                            Object.keys(res.errorMessage).forEach(key => {
                                                this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                            });
                                        }
                                    });
                                } else {
                                    miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                                }
                            });
                        })
                        break;
                }
            }

            this.$refs.pdfModal.hide();
        },
        onAllocateIsos () {
            let data = http.route(this.tableName).get(
            {
                project_id: this.$route.params.id,
                allocate_isometrics: 1
            }, true);
            data.then(response => {
                if (!response.isError) {
                    this.onLoadTable();
                    this.successMsg(Vue.i18n.translate('messages.isometrics_allocated'));
                } else {
                    this.warnMsg(Vue.i18n.translate('messages.no_isometrics_allocated'));
                }
            });
        },
        onRevision (row) {
            this.$router.push({name: 'pressure_test_planning_revisioncontrol', params: {id:this.$route.params.id, id2: row.id}});
        },
        onClickCheck (row, index, column) {
            if (row) {
                if(column == 'delayed') {
                    if(row.delayed == true && row.delay != null) {
                        http.route('delay/'+row.delay.id).patch({
                            end_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
                            title: row.delay.title,
                            delay_date: row.delay.delay_date,
                            discipline_id: row.delay.discipline_id
                        }, true).then(response => {
                            if(!response.data) {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                                });
                            } else {
                                this.onLoadTable();
                                this.successMsg(Vue.i18n.translate('messages.delay_updated'));
                            }
                        });
                    } else {
                        this.$router.push({name: 'delays'});
                    }
                } else {
                    this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                    var clone = Object.assign({}, row);
                    clone[column.toString()] = !clone[column.toString()];

                    let data = http.route(this.tableName + '/' + row.id).patch(clone, true);
                    data.then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            row[column.toString()] = !row[column.toString()];
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        }
                    });
                    
                    this.model[column.toString()] = null;
                }
            }
        },
        //Lines (P&ID No)
        onLoadLines() {
            this.selectedPAndIdNo = [];
            this.currentPAndIdNo = [];
            http.route('pressuretest/' + this.row.id + '/line').get().then(response => {
                if (!response.isError) {
                    this.selectedPAndIdNo = response.data;
                    this.showPAndIDNo = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        async saveLines(id) {
            return new Promise((resolve, reject) => {
                http.route('pressuretest/' + id + '/line').post({
                    lines: this.selectedPAndIdNo
                }, true)
                .then(res => {
                    resolve();
                });
            });
        },
        //Calibrated Items
        onLoadCalibratedItems() {
            this.selectedCalibratedItem = [];
            this.currentCalibratedItem = [];
            http.route('pressuretest/' + this.row.id + '/calibrated_item').get().then(response => {
                if (!response.isError) {
                    this.selectedCalibratedItem = response.data;
                    this.showCalibratedItem = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        async saveCalibratedItems(id) {
            return new Promise((resolve, reject) => {
                http.route('pressuretest/' + id + '/calibrated_item').post({
                    calibrated_items: this.selectedCalibratedItem
                }, true)
                .then(res => {
                    resolve();
                });
            });
        },
        onColumnClick(row, index, column) {
            this.$store.state.go_back_data_list[1] = this.row.id;
            this.$store.state.go_back_url = 'pressure_test_planning';

            if (index == 4) {
                this.$store.state.go_back_data_list[0] = row.line.id;
                this.$router.push({name: 'line_list', params: {id: this.$route.params.id}});
            } else if(index == 12) {
                this.$store.state.go_back_data_list[0] = row.line.tie_in.id;
                this.$router.push({name: 'tieinmanagement', params: {id: this.$route.params.id}});
            }
        },
        onExportButton() {
            http.route('pressuretest?project_id=' + this.$route.params.id).exportExcel({
                export:1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'pressure_test_planning.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            formData.append('project_id', this.$route.params.id);
            formData.append('type', 'iso');

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            http.route('pressuretest/import').importExcel(formData)
            .then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
                }
            });
        },
        //Blinds
        onLoadBlinds() {
            http.route('blind?project_id=' + this.$route.params.id + '&filters[pressure_test_id]=' + this.row.id).get().then(response => {
                if (!response.isError) {
                    response.data.forEach(field => {
                        if (typeof this.$refs.blindsModal.measure_units[field.unit].name != 'undefined') {
                            field.unitV = this.$refs.blindsModal.measure_units[field.unit].name;
                        }
                    });
                    this.getData.blindsData = response.data;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddBlind() {
            this.actionTitleBlind = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.blind.title');

            this.$refs.blindsModal.clear();
            this.blinds_model.pressure_test_id = this.row.id;

            this.$refs.blindsModal.show();
        },
        onEditBlindRow(row) {
            this.actionTitleBlind = Vue.i18n.translate('modal.general.edit') + ' ' + Vue.i18n.translate('general.blind.title_modal');
            this.rowBlind = row;

            this.$refs.blindsModal.clear();
            this.blinds_model.id = row.id;
            this.blinds_model.pressure_test_id = row.pressure_test_id;
            this.blinds_model.project_setting_id = row.project_setting_id;
            this.blinds_model.project_setting_description = row.project_setting_description;
            this.blinds_model.standard = row.standard;
            this.blinds_model.size = row.size;
            this.blinds_model.rating = row.rating;
            this.blinds_model.qty = row.qty;
            this.blinds_model.unit = row.unit;
            this.blinds_model.installed = row.installed;
            this.blinds_model.removed = row.removed;
            this.blinds_model.all_installed = Boolean(row.all_installed);
            this.blinds_model.all_removed = Boolean(row.all_removed);
            this.blinds_model.remark = row.remark;

            this.$refs.blindsModal.show();
        },
        onDeleteBlindRow(row) {
            this.actionTitleBlind = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.blind.title_modal');
            this.rowBlind = row;
            this.$refs.deleteBlindModal.show();
        },
        deleteBlindAction(button) {
            if(button == 1) {
                http.route('blind/' + this.rowBlind.id).delete().then(response => {
                    if (!response.isError) {
                        this.onEditRow(this.row);
                        this.successMsg(Vue.i18n.translate('general.blind.title_modal') + ' ' + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteBlindModal.hide();
        },
        onClickCheckBlinds(row, index, column) {
            if (row) {
                this.blinds_model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];

                let data = http.route('blind/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        this.successMsg(Vue.i18n.translate('general.blind.title_modal') + Vue.i18n.translate('messages.updated'));
                    }
                });
                this.blinds_model[column.toString()] = null;
            }
        },
        //Removed Items
        onLoadRemovedItems() {
            http.route('removed_item?project_id=' + this.$route.params.id + '&filters[pressure_test_id]=' + this.row.id).get().then(response => {
                if (!response.isError) {
                    response.data.forEach(field => {
                        if (typeof this.$refs.blindsModal.measure_units[field.unit].name != 'undefined') {
                            field.unitV = this.$refs.blindsModal.measure_units[field.unit].name;
                        }
                    });
                    this.getData.removedItemsData = response.data;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddRemovedItem() {
            this.actionTitleRemoved = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.removed_item.title');

            this.$refs.removedItemsModal.clear();
            this.removedItems_model.pressure_test_id = this.row.id;

            this.$refs.removedItemsModal.show();
        },
        onEditRemovedItemRow(row) {
            this.actionTitleRemoved = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.removed_item.title_modal');
            this.rowRemovedItem = row;

            this.$refs.removedItemsModal.clear();
            this.removedItems_model.id = row.id;
            this.removedItems_model.pressure_test_id = row.pressure_test_id;
            this.removedItems_model.project_setting_id = row.project_setting_id;
            this.removedItems_model.project_setting_description = row.project_setting_description;
            this.removedItems_model.id_number = row.id_number;
            this.removedItems_model.standard = row.standard;
            this.removedItems_model.size = row.size;
            this.removedItems_model.rating = row.rating;
            this.removedItems_model.qty = row.qty;
            this.removedItems_model.unit = row.unit;
            this.removedItems_model.installed = row.installed;
            this.removedItems_model.removed = row.removed;
            this.removedItems_model.all_installed = Boolean(row.all_installed);
            this.removedItems_model.all_removed = Boolean(row.all_removed);
            this.removedItems_model.remark = row.remark;

            this.$refs.removedItemsModal.show();
        },
        onDeleteRemovedItemRow(row) {
            this.rowRemovedItem = row;
            this.actionTitleRemoved = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.removed_item.title_modal')
            this.$refs.deleteRemovedItemModal.show();
        },
        deleteRemovedItemAction(button) {
            if (button == 1) {
                http.route('removed_item/' + this.rowRemovedItem.id).delete().then(response => {
                    if (!response.isError) {
                        this.onEditRow(this.row);
                        this.successMsg(Vue.i18n.translate('general.removed_item.title_modal') + ' ' + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteRemovedItemModal.hide()
        },
        onClickCheckRemovedItems(row, index, column) {
            if (row) {
                this.removedItems_model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];

                let data = http.route('removed_item/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        this.successMsg(Vue.i18n.translate('general.removed_item.title_modal') + Vue.i18n.translate('messages.updated'));
                    }
                });

                this.removedItems_model[column.toString()] = null;
            }
        },
        //Isometrics
        onLoadIsometrics() {
            http.route('pressuretest/' + this.row.id + '/drawing').get().then(response => {
                if (!response.isError) {
                    var data = response.data;
                    data.forEach((field, key) => {
                        if (field.progress_status == null) {
                            field.progress_status = { 
                                'key': '' 
                            };
                        }

                        if (field.line.tie_in == null) {
                            field.line.tie_in = {
                                'tie_in_nr': ''
                            };
                        }

                        this.getData.rowColors[key] = {};

                        if (field.line.testing_med != this.row.testing_medium) {
                            this.getData.rowColors[key]['line.testing_med'] = '#ff471a';
                        }

                        if (field.line.testing_press != this.row.testing_pressure) {
                            this.getData.rowColors[key]['line.testing_press'] = '#ff471a';
                        }

                        if (field.line.ped_category != this.row.ped_category) {
                            this.getData.rowColors[key]['line.ped_category'] = '#ff471a';
                        }

                        if (field.line.test_circuit_no != this.row.test_circuit_no) {
                            this.getData.rowColors[key]['line.test_circuit_no'] = '#ff471a';
                        }

                        let index = this.selectedPAndIdNo.findIndex((item) => item.p_and_id_no === field.line.p_and_id_no);
                        if (index == -1) {
                            this.getData.rowColors[key]['line.p_and_id_no'] = '#ff471a';
                        }
                    });

                    this.getData.isometricsData = data;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddIsometric() {
            this.actionTitleIsometric = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.isometric_management.title_modal');
            this.selectedIsometric = null;
            this.currentIsometrics = [];
            this.$refs.addIsometricModal.show();
        },
        saveIsometricAction(e) {
            e.preventDefault();

            if (this.selectedIsometric == null) {
                this.errorMsg(Vue.i18n.translate('errors.isometric.required'));
                return 0;
            }

            http.route('pressuretest/' + this.row.id + '/drawing').post({
                drawing_id: this.selectedIsometric.id,
            }, true).then(response => {
                if (!response.isError) {
                    this.onEditRow(this.row);
                    this.successMsg(Vue.i18n.translate('general.isometric_management.title_modal') + ' ' + Vue.i18n.translate('messages.created'));
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onDeleteIsometricRow(row) {
            this.actionTitleIsometric = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.isometric_management.title_modal')
            this.rowIsometric = row;
            this.$refs.deleteIsometricModal.show();
        },
        deleteIsometricAction(button) {
            if(button == 1) {
                http.route('pressuretest/' + this.row.id + '/drawing/' + this.rowIsometric.id).delete().then(response => {
                    if (!response.isError) {
                        this.onEditRow(this.row);
                        this.successMsg(Vue.i18n.translate('general.isometric_management.title_modal') + ' ' + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteIsometricModal.hide();
        },
        //Working History
        onLoadWorkHistoryTable () {
            http.route('history?project_id=' + this.$route.params.id + '&filters[from_table]=pressure_test&filters[from_id]=' + this.row.id).get().then(response => {
                if(!response.isError) {
                    this.getData.workHistoryData = response.data;
                    this.getData.workHistoryData.filter(function(value, key) {
                        if (value.project_setting == null) {
                            value.project_setting = '';
                        }
                    });
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onTaskWorkingRow (row, index) {
            this.actionTitleTask = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.administrative.task_manager.title_modal');
            this.task_model.id = null;
            this.task_model.task_title = row.project_setting.value;
            this.task_model.selectedToTeam = row.team;
            this.task_model.selectedDiscipline = this.row.discipline;
            this.task_model.exact_date = row.date;
            this.task_model.loggedUser = this.$store.state.user.user.firstname + ' ' + this.$store.state.user.user.lastname;
            this.specialInputs = [false, false, true];
            this.$refs.taskModal.show();
        },
        onAddWorkingHistory() {
            this.actionTitleWork = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.isometric_management.working_history_title');
            this.$refs.historyModal.clear();
            this.working_model.from_id = this.row.id;
            this.$refs.historyModal.show();
        },
        onEditWorkingRow(row) {
            this.actionTitleWork = Vue.i18n.translate('modal.general.edit') + ' ' + Vue.i18n.translate('general.isometric_management.working_history_title');
            this.rowHistory = row;
            this.working_model.id = this.rowHistory.id;
			this.working_model.from_id = this.rowHistory.from_id;
			this.working_model.team_id = this.rowHistory.team_id;
			this.working_model.user_id = this.rowHistory.user_id;
			this.working_model.date = this.rowHistory.date;
			this.working_model.remark = this.rowHistory.remark;
			this.working_model.team = this.rowHistory.team;
			this.working_model.user = this.rowHistory.user;
			this.working_model.project_setting = this.rowHistory.project_setting;
            this.$refs.historyModal.show();
        },
        onDeleteWorkingRow(row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.isometric_management.working_history_title');
            this.rowHistory = row;
            this.delete_message = Vue.i18n.translate('messages.delete_history');
            this.$refs.deleteModalWorking.show();
        },
        deleteActionWorking (button)  {
            if (button == 1){
                let data = http.route('history/' + this.rowHistory.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        this.onLoadWorkHistoryTable();
                        this.successMsg(Vue.i18n.translate('messages.deleted_history_message'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModalWorking.hide();
        },
        onPressureTestTeamSearch(search) {
            if (search == '') {
                this.currentPressureTestTeam = [];
                
                return false;
            }

            this.isPressureTestTeamLoading = true;
            this.searchPressureTestTeam(search, this);
        },
        searchPressureTestTeam: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPressureTestTeam = response.data;
                }
                vm.isPressureTestTeamLoading = false;
            });
        }, 500),
        updatePressureTestTeam(team) {
            this.currentPressureTestUser  = [];
            this.selectedPressureTestUser = null;
            this.model.pressure_test_user_id = null;

            if (team == null) {
                this.model.pressure_test_team_id = null;
                this.currentPressureTestUser = [];
            } else {
                this.model.pressure_test_team_id = team.id;

                http.route('team/' + team.id +'/members?project_id='+this.$route.params.id).get().then(response => {
                    if (response.data != false) {
                        this.currentPressureTestUser = response.data;
                    }
                });
            }
        },
        clearSelectedPressureTestTeam () {
            this.selectedPressureTestTeam    = null;
            this.model.pressure_test_team_id = null;
        },
        onPressureTestUserSearch(search) {
            if (search == '') {
                this.currentPressureTestUser = [];
                
                return false;
            }

            this.isPressureTestUserLoading = true;
            this.searchPressureTestUser(search, this);
        },
        searchPressureTestUser: _.debounce((search, vm) => {
            if (vm.model.pressure_test_team_id) {
                let data = http.route('team/' + vm.model.pressure_test_team_id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentPressureTestUser = response.data;
                    }
                    vm.isPressureTestUserLoading = false;
                });
            }
        }, 500),
        updatePressureTestUser(pressure_test_user) {
            this.model.pressure_test_user_id = (pressure_test_user != null) ? pressure_test_user.user_id : null;
        },
        clearSelectedPressureTestUser () {
            this.selectedPressureTestUser    = null;
            this.model.pressure_test_user_id = null;
        },
        onPAndIdNoSearch(search) {
            if (search == '') {
                this.currentPAndIdNo = [];
                
                return false;
            }

            this.isPAndIdNoLoading = true;
            this.searchPAndIdNo(search, this);
        },
        searchPAndIdNo: _.debounce((search, vm) => {
            let data = http.route('line?project_id='+ vm.$route.params.id +'&get_all=1&search_select_p_and_id_no=' + search + '&filters[parent_line_id]=null').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPAndIdNo = [];
                    response.data.forEach(field => {
                        if (field.p_and_id_no != null) {
                            vm.currentPAndIdNo.push(field);
                        }
                    });
                }
                vm.isPAndIdNoLoading = false;
            });
        }, 500),
        updatePAndIdNo(line) {
        },
        onCalibratedItemSearch(search) {
            if (search == '') {
                this.currentCalibratedItem = [];
                
                return false;
            }

            this.isCalibratedItemLoading = true;
            this.searchCalibratedItem(search, this);
        },
        searchCalibratedItem: _.debounce((search, vm) => {
            let data = http.route('calibrated_item?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCalibratedItem = response.data;
                }
                vm.isCalibratedItemLoading = false;
            });
        }, 500),
        updateCalibratedItem(calibrated_item) {
        },
        onReinstallmentGroupSearch(search) {
            if (search == '') {
                this.currentReinstallmentGroup = [];
                
                return false;
            }

            this.isReinstallmentGroupLoading = true;
            this.searchReinstallmentGroup(search, this);
        },
        searchReinstallmentGroup: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentReinstallmentGroup = response.data;
                }
                vm.isReinstallmentGroupLoading = false;
            });
        }, 500),
        updateReinstallmentGroup(team) {
            this.model.reinstallment_group_id = (team != null) ? team.id : null;
        },
        clearSelectedReinstallmentGroup () {
            this.selectedReinstallmentGroup   = null;
            this.model.reinstallment_group_id = null;
        },
        onWorkingGroupSearch(search) {
            if (search == '') {
                this.currentWorkingGroup = [];
                
                return false;
            }

            this.isWorkingGroupLoading = true;
            this.searchWorkingGroup(search, this);
        },
        searchWorkingGroup: _.debounce((search, vm) => {
            let data = http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentWorkingGroup = response.data;
                }
                vm.isWorkingGroupLoading = false;
            });
        }, 500),
        updateWorkingGroup(team) {
            this.model.working_group_id = (team != null) ? team.id : null;
        },
        clearSelectedWorkingGroup () {
            this.selectedWorkingGroup   = null;
            this.model.working_group_id = null;
        },
        filterSearch (from, compare) {
            var that = this;
            return from.filter(function(value, key) {
                return !compare.find(x => x.id == value.id);
            });
        },
        onDrawingSearch(search) {
            if (search == '') {
                this.currentIsometrics = [];
                
                return false;
            }

            this.isIsometricLoading = true;
            this.searchDrawings(search, this);
        },
        searchDrawings: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[parent_drawing_id]=null&filters[discipline_id]='+1).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentIsometrics = vm.filterSearch(response.data, vm.getData.isometricsData);
                }
                vm.isIsometricLoading = false;
            });
        }, 500),
        onTestingMediumSearch(search) {
            if (search == '') {
                this.currentTestingMedium = [];
                
                return false;
            }

            this.currentTestingMedium = [];
            this.searchTestingMedium(search, this);
        },
        searchTestingMedium: _.debounce((search, vm) => {
            let data = http.route('line?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search + '&filters[parent_line_id]=null&filters[distinct]=testing_med').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTestingMedium = [];
                    var temp = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if(response.data[i].testing_med != null) {
                            temp.push(response.data[i].testing_med.toString());
                        }
                    }
                    vm.currentTestingMedium = temp;
                }
            });
        }, 500),
        onTestingPressureSearch(search) {
            if (search == '') {
                this.currentTestingPressure = [];
                
                return false;
            }

            this.currentTestingPressure = [];
            this.searchTestingPressure(search, this);
        },
        searchTestingPressure: _.debounce((search, vm) => {
            let data = http.route('line?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search + '&filters[parent_line_id]=null&filters[distinct]=testing_press').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentTestingPressure = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if(response.data[i].testing_press != null) {
                            vm.currentTestingPressure.push(response.data[i].testing_press.toString());
                        }
                    }
                }
            });
        }, 500),
        onPedCategorySearch(search) {
            if (search == '') {
                this.currentPedCategory = [];
                
                return false;
            }

            this.currentPedCategory = [];
            this.searchPedCategory(search, this);
        },
        searchPedCategory: _.debounce((search, vm) => {
            let data = http.route('line?project_id='+ vm.$route.params.id +'&get_all=1&search_select=' + search + '&filters[parent_line_id]=null&filters[distinct]=ped_category').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentPedCategory = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if(response.data[i].ped_category != null) {
                            vm.currentPedCategory.push(response.data[i].ped_category.toString());
                        }
                    }
                }
            });
        }, 500),
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/pressure_test_planning/pressure_test_planning.vue